module.exports = __webpack_public_path__ + "img/img_student1.ddfbc688.png";